{
  "title": "Conjure Minor Elementals",
  "source": "Player's Handbook",
  "levelAndSchool": "4th-level conjuration",
  "level": 4,
  "castingTime": "1 minute",
  "range": "90 feet",
  "components": "V, S",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You summon elementals that appear in unoccupied spaces that you can see within range. You choose one the following options for what appears:",
    "One elemental of challenge rating 2 or lower",
    "Two elementals of challenge rating 1 or lower",
    "Four elementals of challenge rating 1/2 or lower",
    "Eight elementals of challenge rating 1/4 or lower",
    "An elemental summoned by this spell disappears when it drops to 0 hit points or when the spell ends.",
    "The summoned creatures are friendly to you and your companions. Roll initiative for the summoned creatures as a group, which has its own turns. They obey any verbal commands that you issue to them (no action required by you). If you don’t issue any commands to them, they defend themselves from hostile creatures, but otherwise take no actions. The DM has the creatures’ statistics.",
    "At Higher Levels. When you cast this spell using certain higher-level spell slots, you choose one of the summoning options above, and more creatures appear: twice as many with a 6th-level slot and three times as many with an 8th-level slot."
  ],
  "spellLists": ["druid", "wizard"]
}
